import React from "react";

import { BettingActivityReviewReportDto } from "@api-types/reports/ReportResultDto";
import { WalletIcon } from "@components/icons/WalletIcon";
import { getDisplayedAmount } from "@utils";
import classNames from "classnames";

export default function AccountStatementBettingTableItem(props: {
	tableItem: BettingActivityReviewReportDto;
}) {
	if (!props.tableItem) {
		return null;
	}

	const paymentClass = classNames(
		"table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium",
		{
			"u-color--sent--danger": props.tableItem.Payment < 0,
		}
	);

	const gainClass = classNames(
		"table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium",
		{
			"u-color--sent--success": props.tableItem.Gain > 0,
		}
	);

	const netGainClass = classNames(
		"table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium",
		{
			"u-color--sent--success": props.tableItem.NetGain > 0,
			"u-color--sent--danger": props.tableItem.NetGain < 0,
		}
	);

	const lossClass = classNames(
		"table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium",
		{
			"u-color--sent--danger": props.tableItem.Loss < 0,
		}
	);

	return (
		<>
			<tr className="table__body__tr table__row">
				<td className="table__body__cell table__cell table__cell--sml table__cell--icon-only">
					<WalletIcon
						bettingAccountTypeAbrv={
							props.tableItem.BettingAccountTypeAbrv
						}
						marginReset
					/>
				</td>
				<td className="table__body__cell table__cell table__cell--sml u-color--text--primary">
					{props.tableItem.NumberOfBets}
				</td>
				<td className={paymentClass}>
					{getDisplayedAmount(
						props.tableItem.Payment,
						props.tableItem.DisplayCode
					)}
				</td>
				<td className={gainClass}>
					{getDisplayedAmount(
						props.tableItem.Gain,
						props.tableItem.DisplayCode
					)}
				</td>
				<td className={netGainClass}>
					{getDisplayedAmount(
						props.tableItem.NetGain,
						props.tableItem.DisplayCode
					)}
				</td>
				<td className={lossClass}>
					{getDisplayedAmount(
						props.tableItem.Loss,
						props.tableItem.DisplayCode
					)}
				</td>
			</tr>
		</>
	);
}
